import api from 'Application/api/api';

const getInquiriesFilterRange = async signal => {
	const response = await api.get('/inquiries/filters-range', {
		signal,
	});

	return {
		...response,
	};
};

export default getInquiriesFilterRange;
